import PropTypes from 'prop-types';
import React from 'react';
import { useRouter } from 'next/router';
import DesktopNav from './faq-nav-desktop';
import MobileNav from './faq-nav-mobile';

/**
 * FAQNav includes a mobile and desktop nav.
 * The mobile nav is a Select component and the desktop nav is hidden with css.
 */
const FAQNav = ({ links, currentRoute }) => {
  const router = useRouter();

  const onChange = (e) => {
    router.push(e.value);
  };

  // Make a copy of links for mobile nav
  const mobileLinks = links.slice();

  // Add Overview link to mobile nav
  mobileLinks.unshift({
    route: '/faq/',
    text: 'Overview',
  });

  const label = 'Topics';
  const placeholder = 'Select a topic';

  return (
    <nav aria-label='FAQ Navigation' className='FAQNav'>
      <DesktopNav links={links} label={label} />
      <MobileNav
        links={mobileLinks}
        label={label}
        currentRoute={currentRoute}
        placeholder={placeholder}
        // eslint-disable-next-line react/jsx-no-bind
        onChange={onChange} />
    </nav>
  );
};

FAQNav.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    route: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  currentRoute: PropTypes.string.isRequired,
};

export default FAQNav;
